var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vgs-message",class:_vm.mode},[_c('div',{staticClass:"icon"},[_c('IconSet',{attrs:{"icon":"alert","state":""}})],1),_c('div',{staticClass:"headline"},[_vm._v(_vm._s(this.headline))]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }